import { useState, useRef, useEffect } from 'react'

// Copied from LegacyNavigation's user menu, trimmed to what the redesigned avatar
// dropdown needs: open state plus close-on-outside-click and close-on-Escape. The
// legacy guest login/register popover handling is intentionally left out - the new
// nav keeps its guest auth as plain links.
function useUserMenu() {
  const [isOpen, setIsOpen] = useState(false)
  const wrapperRef = useRef(null)
  const isOpenRef = useRef(isOpen)

  useEffect(() => {
    isOpenRef.current = isOpen
  }, [isOpen])

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside)
    document.addEventListener('keydown', handleKeyDown)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
      document.removeEventListener('keydown', handleKeyDown)
    }
  }, [])

  function handleClickOutside(e) {
    const currentRef = wrapperRef.current

    if (isOpenRef.current && currentRef && !currentRef.contains(e.target)) {
      setIsOpen(false)
    }
  }

  function handleKeyDown(e) {
    if (e.key === 'Escape' && isOpenRef.current) {
      setIsOpen(false)
    }
  }

  return { isOpen, setIsOpen, wrapperRef }
}

export { useUserMenu }
